import {
  Box,
  Button,
  IconButton,
  Pagination as MuiPagination,
  Typography,
} from '@mui/material';
import type { BoxProps } from '@mui/material';

import { useBreakpoint } from '@shared/lib/hooks';

import { ArrowNarrowLeftIcon, ArrowNarrowRightIcon } from '../icons';

type PaginationProps = {
  count: number;
  page: number;
  onPageChange: (page: number) => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  compact?: boolean;
  containerProps?: BoxProps;
};

export const Pagination = (props: PaginationProps) => {
  const {
    count,
    page,
    onPageChange,
    canPreviousPage,
    canNextPage,
    compact,
    containerProps,
  } = props;
  const breakpoint = useBreakpoint();

  const isCompact = compact || breakpoint.isMobile;

  if (isCompact) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={2}
        {...containerProps}
      >
        <IconButton
          disabled={!canPreviousPage}
          onClick={() => onPageChange(page - 1)}
          size="medium"
        >
          <ArrowNarrowLeftIcon />
        </IconButton>
        <Typography variant="body2">
          {page} з {count}
        </Typography>
        <IconButton
          disabled={!canNextPage}
          onClick={() => onPageChange(page + 1)}
          size="medium"
        >
          <ArrowNarrowRightIcon />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      {...containerProps}
    >
      <Button
        startIcon={<ArrowNarrowLeftIcon />}
        disabled={!canPreviousPage}
        onClick={() => onPageChange(page - 1)}
      >
        Попередня
      </Button>
      <MuiPagination
        count={count}
        page={page}
        onChange={(_, newPage) => onPageChange(newPage)}
        hidePrevButton
        hideNextButton
        siblingCount={1}
        boundaryCount={1}
      />
      <Button
        endIcon={<ArrowNarrowRightIcon />}
        disabled={!canNextPage}
        onClick={() => onPageChange(page + 1)}
      >
        Наступна
      </Button>
    </Box>
  );
};
